import { theme } from '../../config/theme';

/** Общие стили нижней панели плеера — пергамент, в тон основному UI */
export const playerBarStyles = {
    playerFixed: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: `linear-gradient(180deg, ${theme.colors.parchmentLight} 0%, ${theme.colors.parchment} 55%, ${theme.colors.parchmentDark} 100%)`,
        borderTop: `2px solid ${theme.colors.borderDark}`,
        boxShadow: '0 -8px 28px rgba(80, 55, 30, 0.18)',
    },
    playerInner: {
        maxWidth: 1000,
        margin: '0 auto',
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,
    },
    playerContent: {
        flex: 1,
        minWidth: 0,
    },
    playerTitle: {
        margin: 0,
        marginBottom: theme.spacing.xs,
        flex: 1,
        minWidth: 0,
        fontSize: theme.fontSize.base,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.ink,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    playerTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,
        marginBottom: theme.spacing.xs,
    },
    playerTitleCommentary: {
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontStyle: 'italic',
        color: theme.colors.textSecondary,
    },
    playerCheckboxRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.lg,
        flexWrap: 'wrap',
        marginBottom: theme.spacing.xs,
    },
    playerCheckbox: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.xs,
        fontSize: theme.fontSize.sm,
        color: theme.colors.ink,
        cursor: 'pointer',
        userSelect: 'none',
    },
    playerCheckboxDisabled: {
        color: theme.colors.textTertiary,
    },
    playerNavBtn: {
        width: 44,
        height: 44,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.ink,
        backgroundColor: theme.colors.parchmentPaper,
        border: `2px solid ${theme.colors.ink}`,
        borderRadius: theme.borderRadius.md,
        cursor: 'pointer',
        boxShadow: theme.shadows.sm,
    },
    playerNavBtnDisabled: {
        opacity: 0.45,
        cursor: 'not-allowed',
    },
    addPlaylistBtnPlayer: {
        flexShrink: 0,
        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.semibold,
        cursor: 'pointer',
        border: `2px solid ${theme.colors.ink}`,
        borderRadius: theme.borderRadius.md,
        backgroundColor: theme.colors.parchmentPaper,
        color: theme.colors.ink,
    },
    addPlaylistBtnPlayerAdded: {
        flexShrink: 0,
        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.success,
    },
    audioWrap: {
        padding: theme.spacing.xs,
        borderRadius: theme.borderRadius.lg,
        backgroundColor: 'rgba(255, 252, 245, 0.72)',
        border: `1px solid ${theme.colors.borderMedium}`,
        boxShadow: 'inset 0 1px 3px rgba(60, 40, 20, 0.08)',
    },
    audio: {
        width: '100%',
        height: 40,
        display: 'block',
    },
};
